import styled from 'styled-components';
import {color, space, layout, border, background, LayoutProps, SpaceProps, ColorProps, BorderProps, BackgroundProps} from 'styled-system';
import Btn from 'react-bootstrap/Button';
import {Link} from 'react-router-dom';

interface ITrovaButton extends LayoutProps, SpaceProps{
  size?: string,
}

interface ButtonProps extends ColorProps, LayoutProps, SpaceProps, BorderProps, BackgroundProps{}

interface ISize{
  [key:string]: any,
}

const sizeProps:ISize = {
  lg: {
    'font-size': '16px',
    'line-height': '136%',
    'font-weight': 600,
    'padding': '14px 54px',
    'border-radius': '8px'
  },
  md: {
    'font-size': '14px',
    'line-height': '115%',
    'font-weight': 600,
    'padding': '14px 40px',
    'border-radius': '8px'
  },
  sm: {
    'font-size': '12px',
    'line-height': '14px',
    'font-weight': 600,
    'padding': '4px 8px',
    'border-radius': '4px'
  }
}

export const TrovaButton = styled(Btn)<ITrovaButton>`
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  ${props => {
    if (props.size && sizeProps[props.size]) {
      return sizeProps[props.size]
    }
    return sizeProps.md
  }}
  color: #fff;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%) ;
  border-width: 0;
  white-space: nowrap;
  ${layout}
  ${space}

  :hover{
    color: #fff;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  }
  :focus{
    color: #fff;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
  }
  :disabled{
    color: #fff;
    opacity: 0.3;
  }
`

export const SignInButton = styled(Link)`
  width: 124px;
  height: 48px;
  line-height: 36px;
  background-color: #80ABED;
  box-sizing: border-box;
  border-radius: 8px ;
  display: flex ;
  justify-content: center;
  align-items: center;
  border: none;
  color: #fff;
  :hover{
    filter: drop-shadow(-8.49px -8.49px 5px rgba(255, 255, 255, 0.33)), drop-shadow(8.17px 8.17px 12px rgba(36, 38, 89, 0.1));
    border: none;
    text-decoration: none;
    color: #fff;
  }
  :focus{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border: none;
  }
  :not(:disabled):not(.disabled):active{
    border: none;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    background-color: #80ABED;
    border-width: 0;
  }
`

export const Button = styled(Btn)<ButtonProps>`
  font-family: "Open Sans", Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  ${color}
  ${space}
  ${layout}
  ${border}
  ${background}
`
